import React from "react";
import Loading from "../../common/Loading";
import SignupDescriptionV2 from "./SignupDescriptionV2";
import BasicInfoForm from "./BasicInfoForm";

import logoBlack from "../../../assets/tomo_logo_black.svg";

const BasicInfoDesktop = ({ loading, email, referralCode, _completeStep, createUserError }) => {

  return (
    <>
      {loading ? <Loading showBackdrop/> : null}
      <div className="h-full" >
        <SignupDescriptionV2 />
        <div className="halfStepContainer flex-col justify-end">
          <div className="flex flex-1">
            <div className="self-center w-full">
              <img src={logoBlack} className="mx-auto" alt="Tomo" />
              <div id="stepContent" className="m-auto w-80percent md:mt-6">
                <div className="stepDescriptionText2">Create your account</div>
                <p className="pb-5 -mt-6 text-gray-800 md:hidden">
                  Good news! We don&apos;t pull your credit.
                </p>
                <BasicInfoForm
                  email={email}
                  referralCode={referralCode}
                  _completeStep={_completeStep}
                  loading={loading}
                />
                {createUserError && <div className="errorText mb-4">{createUserError}</div>}

                <div className="font-open-sans">
                  <span className="text-gray-600">
                    Already have an account?
                  </span>{" "}
                  <a className="underline text-gray-600" href="/register/login">
                    Sign in
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="py-5">
            <span className="font-open-sans">
              <i className="far fa-solid fa-shield-halved mr-2 text-purple-400" />
              Protected with Bank Level Security.
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default BasicInfoDesktop;